export const fetchMatas = () =>
    window.fetch('https://akademia.uczymydzieciprogramowac.pl/pl/api/matas')
        .then(response => {
            return response.json();
        })
        .then(data => {
            return data;
        });

export const postMata = mata =>
    window.fetch('https://akademia.uczymydzieciprogramowac.pl/pl/api/matas', {
            method: 'POST',
            body: JSON.stringify({
                mata: {
                    type: mata.type,
                    data: mata.data,
                    commands: mata.commands
                }
            })
        }
    ).then(response => {
        return response.json();
    }).then(data => {
        return data;
    })
;


export const deleteMata = hash =>
    window.fetch('https://akademia.uczymydzieciprogramowac.pl/pl/api/matas/hash/' + hash, {
        method: 'DELETE'
    })
        .then(response => {
            return response;
        });

export const getMata = hash =>
    window.fetch('https://akademia.uczymydzieciprogramowac.pl/pl/api/matas/hash/' + hash, {
        method: 'GET'
    })
        .then(response => {
            return response.json();
        });










// WEBPACK FOOTER //
// ./src/api.js